import { render, staticRenderFns } from "./AssessmentSetting.vue?vue&type=template&id=866c15f2"
import script from "./AssessmentSetting.vue?vue&type=script&lang=js"
export * from "./AssessmentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports